export enum GongCallStatus {
  PENDING = "pending",
  REVIEW = "review",
  PROCESSED = "processed",
  ARCHIVED = "archived",
}

export enum GongCallStatusLabel {
  PENDING = "Pending",
  REVIEW = "Review",
  PROCESSED = "Processed",
  ARCHIVED = "Archived",
}
